import { createApiSlice } from "@common";
import {
  CURD_CUSTOMERS,
  CURD_CUSTOMERS_BY_ID,
  CURD_CUSTOMERS_BY_OWNER,
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addCustomers",
    method: "post",
    url: CURD_CUSTOMERS,
    stateKey: "message",
  },
  {
    name: "getCustomers",
    method: "get",
    url: CURD_CUSTOMERS,
    stateKey: "data",
  },
  {
    name: "getCustomersByOwner",
    method: "get",
    url: CURD_CUSTOMERS_BY_OWNER,
    stateKey: "data",
  },
  {
    name: "updateCustomers",
    method: "put",
    url: CURD_CUSTOMERS,
    stateKey: "message",
  },
  {
    name: "deleteCustomers",
    method: "delete",
    url: CURD_CUSTOMERS,
    stateKey: "message",
  },
  {
    name: "getCustomersDetails",
    method: "get",
    url: CURD_CUSTOMERS_BY_ID,
    stateKey: "details",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
    details: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "customer",
  apiConfig,
  customReducers,
);
const customerSlice = slice;
// Export the slice's reducer
export default customerSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addCustomers,
  getCustomers,
  getCustomersByOwner,
  updateCustomers,
  deleteCustomers,
  getCustomersDetails
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect } =
  actions;
